<template>
  <div>
    <CustomerActionButton
      class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-text-red-500 hover:tw-text-white tw-bg-white tw-border tw-border-solid tw-border-red-600 tw-rounded-md hover:tw-bg-red-500 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-red-500 focus:tw-border-red-500"
      type="button"
      @click="showDeleteConfirmationModal = true"
    >
      <TrashIcon />
      {{ t('customer_management.actions.delete_selected_projects') }}
    </CustomerActionButton>

    <ConfirmationModal
      v-model="showDeleteConfirmationModal"
      :title="t('common.titles.attention').toUpperCase()"
      :message="`${t('customer_management.actions.delete_confirmation_title')} ${
        props.selectedProjects.length
      } ${t('customer_management.titles.projects')}`"
      type="danger"
      :confirm-text="t('common.forms.confirm')"
      :cancel-text="t('common.forms.cancel')"
      @confirm="onDeleteConfirmation"
      @cancel="closeDeleteConfirmationModal"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { ConfirmationModal } from '@/components/shared';
import { useApiUtils } from '@/_helpers/composables/api-utils.composable';
import { useProjectStore } from '@/stores/project.store';
import CustomerActionButton from '@/components/shared/CustomerActionButton.vue';
import TrashIcon from '@/assets/icons/Trash.svg';

const { handleApiError } = useApiUtils();
const { deleteProject } = useProjectStore();

const props = defineProps<{
  selectedProjects: any[];
}>();

const emit = defineEmits(['reloadTable']);

const showDeleteConfirmationModal = ref(false);

const onDeleteConfirmation = async () => {
  await handleApiError(
    () => deleteProject(props.selectedProjects.map(project => project.id)),
    t('customer_management.actions.project_deleted_successfully')
  );
  emit('reloadTable');
};

const closeDeleteConfirmationModal = () => {
  showDeleteConfirmationModal.value = false;
};

const { t } = useI18n();
</script>
